import { createContext } from 'react';

const InitialState = {
  chimeSettings: {
    drawerState: false,
    step: 1,
    isEdit: false,
    activeUser: {},
  },
};

const actionTypes = {
  SET_CHIME_DRAWER_STATUS: 'SET_CHIME_DRAWER_STATUS',
  SET_CHIME_DRAWER_STEP: 'SET_CHIME_DRAWER_STEP',
  SET_CHIME_DRAWER_IS_EDIT: 'SET_CHIME_DRAWER_IS_EDIT',
  SET_CHIME_DRAWER_ACTIVE_USER: 'SET_CHIME_DRAWER_ACTIVE_USER',
  SET_CHIME_DRAWER_EDIT_MODE: 'SET_CHIME_DRAWER_EDIT_MODE',
  SET_CHIME_DRAWER_CREATE_MODE: 'SET_CHIME_DRAWER_CREATE_MODE',
};

const ChimeContext = createContext(InitialState);
const DispatchChimeContext = createContext();

export { ChimeContext, DispatchChimeContext, InitialState, actionTypes };
